// src/pages/PftMatchCard.js
//
// One possible match for a PFT Uploads card, as shown in the Move pop-up and the
// Move all review: who it is, which box they're in, the studies they're in now, why
// they matched, and a link to their patient page (new tab, so the pop-up stays open).
// Kept short on purpose. Rules in pftMovePlan.js (matchReason, matchBox, ...).
// Colors (2026-10-20): the box is purple; a study is green once an admin approved it,
// amber while it waits (the words say so too, for screen readers and on hover).

import { ExternalLink } from "lucide-react";
import { currentStudies, matchBox, matchReason, patientHref } from "../services/pftMovePlan";

const chip = "inline-flex items-center px-1.5 py-0.5 rounded-md border text-[11px] font-medium";

export default function PftMatchCard({ match }) {
  const r = match.record || {};
  const box = matchBox(match);
  const studies = currentStudies(r);
  return (
    <div className="min-w-0 text-[12px] text-slate-100 space-y-0.5">
      <div>
        <span className="font-semibold">{r.name || r.fullName || "(no name)"}</span> · DOB {r.dob || "—"} · MRN {r.mrn || "—"}
      </div>
      <div className="text-slate-300 flex flex-wrap items-center gap-1">
        Box:{" "}
        {box ? (
          <span className={`pft-box-chip ${chip} bg-purple-500/15 border-purple-400/40 text-purple-200`}>{box}</span>
        ) : (
          "—"
        )}
        {studies.length > 0 && <span className="ml-1">In:</span>}
        {studies.map((s) => (
          <span
            key={s.name}
            title={s.approved ? "Approved by an admin" : "Waiting for admin approval"}
            className={`${chip} ${
              s.approved
                ? "pft-study-approved bg-emerald-500/15 border-emerald-400/40 text-emerald-200"
                : "pft-study-pending bg-amber-500/15 border-amber-400/50 text-amber-200"
            }`}
          >
            {s.name}
            <span className="sr-only">{s.approved ? " (approved)" : " (waiting for admin approval)"}</span>
          </span>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-x-3">
        <span className="text-amber-200">Why: {matchReason(match)}</span>
        <a
          href={patientHref(match)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="inline-flex items-center gap-1 text-sky-300 hover:underline"
          aria-label={`Open ${r.name || r.fullName || "patient"}'s patient page`}
        >
          Open <ExternalLink className="w-3 h-3" />
        </a>
      </div>
    </div>
  );
}
